module.exports = __webpack_public_path__ + "static/media/x-color.9c54dc16.svg";